<template>
   <div class="crud-wrapper">
      <crud-toolbar :isBlocked="formData.blocked" :modal-mode="modalMode" :new-state="newState"
                    :title="modalTitle" @onCommand="toolbarCommand"
                    showBlock></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

         <v-slide-y-transition>
            <v-card :class="{alert: formStatus.alert}" class="form-status-card" flat v-if="formStatus.text">
               <v-card-text class="caption py-2">
                  {{formStatus.text}}
               </v-card-text>
            </v-card>
         </v-slide-y-transition>

         <v-layout row wrap>
            <a-text-field :disabled="!newState" :error-messages="federalError" @blur="onFederalBlur" autofocus
                          label="CPF" ref="atfCPF" :append-icon="(formData.personType==='A') ? 'fas fa-mobile-alt' : ''"
                          sm6 v-mask="'###.###.###-##'" v-model="formData.federalId"
                          validate="required,cpf_cnpj"></a-text-field>
            <a-text-field :append-outer-icon="validPhone ? 'textsms' : ''" :append-outer-icon-cb="sendSMS"
                          label="Celular"
                          sm6 v-mask="['(##) ####-####', '(##) #####-####']"
                          v-model="formData.mobileNumber"></a-text-field>

            <a-text-field label="Nome" text-transform="capitalize" v-model="formData.name"
                          validate="required"></a-text-field>

            <a-date-field :birth-date="{minAge: 18, maxAge:75}" :label="birthLabel" dateFormat="DD/MM/YYYY"
                          sm4 v-model="formData.birth" validate="dateDMY"></a-date-field>
            <a-text-field label="Natural da Cidade" sm5 v-model="formData.bornCity"></a-text-field>
            <!-- <a-text-field label="Estado" sm3 v-model="formData.bornState"></a-text-field> -->
            <a-select-field display-key="code" label="Estado" obj="countryState" sm3
                            v-model="formData.bornState"></a-select-field>
            <a-text-field label="Número RG" sm4 v-model="formData.rgNumber"></a-text-field>
            <a-text-field label="Órgão Expedidor" sm3 v-model="formData.rgAgency"></a-text-field>
            <a-text-field label="UF" sm2 v-model="formData.rgAgencyState"></a-text-field>
            <a-date-field dateFormat="DD/MM/YYYY" label="Data Expedição" sm3
                          v-model="formData.rgIssueDate" validate="dateDMY"></a-date-field>

            <v-flex :key="index" pb-4 v-for="(job,index) in ( formData.jobs ? formData.jobs.filter(j=> !j.removed) : getDefaultJob() )" xs12>
               <v-card style="border-radius: 12px">
                  <v-toolbar card color="secondary" dark dense>
                     <v-toolbar-title>Matrícula/Benefício</v-toolbar-title>
                     <v-spacer></v-spacer>
                     <v-btn @click="addJob" flat icon small>
                        <v-icon>add</v-icon>
                     </v-btn>
                     <v-btn @click="deleteJob(job)" flat icon small v-if="formData.jobs.length > 1">
                        <v-icon small>far fa-trash-alt</v-icon>
                     </v-btn>
                  </v-toolbar>
                  <v-layout pa-3 row wrap>
                     <a-select-field label="Convênio" obj="covenant" sm7
                                     v-model="job.covenantId" validate="required"></a-select-field>
                     <a-text-field label="N° Matrícula/Benefício" sm5 v-model="job.enrollment"
                                   validate="required"></a-text-field>

                     <a-select-field label="Espécie" obj="benefitType" v-if="job.covenantId === 1"
                                     v-model="job.benefitTypeId"></a-select-field>
                    
                    <v-flex pb-0 pt-1 xs12 sm7>
                        <v-select box class="clean-style"
                            label="Órgão"
                            :items="agencyArray(job.covenantId)"
                            placeholder=' '
                            v-model="job.agencyId"
                            validate-on-blur
                        ></v-select>
                    </v-flex>

                     <a-select-field label="Sit. Funcional" obj="customerCategory" sm5
                                     v-model="job.categoryId"></a-select-field>

                     <a-number-field label="Salário" number-mask="fixed_rs" sm4
                                     v-model="job.salary"></a-number-field>
                     <a-number-field label="Descontos" number-mask="fixed_rs" sm4
                                     v-model="job.discounts"></a-number-field>
                     <a-number-field label="Líquido" number-mask="fixed_rs" sm4
                                     v-model="job.netSalary"></a-number-field>

                     <v-flex pb-1 xs12><label class="subheading grey--text">Dados Bancários (Conta Salário)</label>
                     </v-flex>
                     <a-autocomplete-field autoTrigger label="Banco" obj="bank"
                                           v-model="job.bankId"></a-autocomplete-field>
                     <a-text-field label="Agência" sm4 v-mask="['###X', '####-X']"
                                   v-model="job.branchNo"></a-text-field>
                     <a-text-field label="Conta Corrente" sm4
                                   v-mask="['###-X', '####-X', '#####-X', '######-X','#######-X',
                           '########-X','#########-X','##########-X','###########-X','############-X']"
                                   v-model="job.acctNo"></a-text-field>
                     <a-text-field label="Operação" sm4 v-mask="['###']" v-model="job.opNo"></a-text-field>
                  </v-layout>
               </v-card>
            </v-flex>


            <v-flex pb-1 xs12><label class="subheading grey--text">Endereço</label></v-flex>

            <a-text-field @blur="onZipBlur" label="CEP" mask="##.###-###" sm4 :loading="loading"
                          v-model="formData.zipcode"></a-text-field>

            <a-text-field label="Endereço" text-transform="capitalize" v-model="formData.address" sm9></a-text-field>
            <a-text-field label="Número" v-model="formData.addressNumber" sm3></a-text-field>
            <a-text-field label="Complemento" sm6 text-transform="capitalize"
                          v-model="formData.address2"></a-text-field>
            <a-text-field label="Bairro" sm6 text-transform="capitalize" v-model="formData.district"></a-text-field>
            <a-text-field label="Cidade" sm6 text-transform="capitalize" v-model="formData.city"></a-text-field>
            <a-select-field display-key="code" label="Estado" obj="countryState" sm6
                            v-model="formData.state"></a-select-field>

            <a-text-field label="Email" sm12 text-transform="lowercase"
                          v-model="formData.mainEmail" validate="email"></a-text-field>

            <a-text-area-field auto-grow box label="Observações" rows="2" v-model="formData.notes"></a-text-area-field>

         </v-layout>

      </crud-form>

   </div>


</template>

<script>
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

    const jobModel = {
        enrollment: null,
        covenantId: null,
        benefitTypeId: null,
        agencyId: null,
        categoryId: null,
        function: null,
        indicative: null,
        portalPin: null,
        bankId: null,
        branchNo: null,
        acctNo: null,
        opNo: null,
        salary: null,
        discounts: null,
        netSalary: null,
        margin30: null,
        margin5: null,
        removed: false
    };

    export default CrudFormClass.extend({
        name: 'clientForm',
        
        props: {
            editRecord: {
                type: Function,
                required: false
            }
        },

        data: () => ({
            title: 'Cliente',
            formName: 'clientForm',

            federalError: null,

            loading: false,

            formStatus: {},

            formData: {
                id: null,
                personType: null,
                federalId: null,
                name: null,
                birth: null,
                rgNumber: null,
                rgAgency: null,
                rgAgencyState: null,
                rgIssueDate: null,
                bornCity: null,
                bornState: null,
                mother: null,
                spouse: null,
                address: null,
                addressNumber: null,
                address2: null,
                district: null,
                city: null,
                state: null,
                zipcode: null,
                mobileNumber: null,
                mainEmail: null,
                blocked: 0,
                notes: null,
                jobs: [{ ...jobModel }]

            },

            cpfResult: {},

            gridColumns: [
                {
                    dataField: 'doneAt',
                    caption: 'Data',
                    dataType: 'date',
                    format: 'dd/MM/yyyy',
                    width: 100
                },
                {
                    dataField: 'employerName',
                    caption: 'Empresa',
                    minWidth: 120
                },
                {
                    dataField: 'checkAmount',
                    caption: 'Cheque',
                    dataType: 'number',
                    format: {
                        type: 'currency',
                        precision: 2
                    },
                    minWidth: 80
                },
                {
                    dataField: 'fee_total',
                    caption: 'Taxa',
                    dataType: 'number',
                    format: {
                        type: 'currency',
                        precision: 2
                    },
                    minWidth: 80
                },
                {
                    dataField: 'net_total',
                    caption: 'Liquido',
                    dataType: 'number',
                    format: {
                        type: 'currency',
                        precision: 2
                    },
                    minWidth: 80
                }
            ],

            gridOptions: {
                selection: {
                    mode: 'none'
                },
                onRowPrepared: (info) => {
                    if (info.rowType === 'data' && info.data.statusId === 3) {
                        info.rowElement.addClass('red--text');
                    }
                }
            }
        }),

        watch: {
            'formData.covenantId' (newValue) {
                if (+newValue === 1) {
                    this.formData.categoryId = 2;
                }
            },
            'formData.federalId' (newValue) {
                if (this.formStatus.text) {
                    this.formStatus = {};
                }
                if (this.federalError) {
                    this.federalError = null;
                }
            }
        },

        computed: {
            age () {
                if (this.formData.birth) {
                    return this.$moment().diff(this.formData.birth, 'years', false);
                } else {
                    return null;
                }
            },
            validPhone () {
                return this.formData.mobileNumber && this.formData.mobileNumber.length >= 14;
            },
            birthLabel () {
                if (this.age) {
                    return `Nascimento (${this.age} anos)`;
                }
                return 'Nascimento';
            }
        },

        methods: {
            sendSMS () {
                let { name, mobileNumber } = this.formData;
                window.getApp.showModal('SendSMS', {
                    props: {
                        contact: {
                            name,
                            phone: mobileNumber
                        }
                    }
                });
            },
            
            agencyRules (covenantId) {
                let array = [
                    (v) => !!v || 'Requerido',
                    (v) => this.$store.state.company.lookups.covenantAgencies.find(el => el.id == v && el.covenantId === covenantId) != null || 'Requerido'
                ];
                return array
            },

            agencyArray (covenantId){
                return this.$store.state.company.lookups.covenantAgencies
                    .filter(el => el.covenantId == covenantId)
                    .map(obj => Object({
                        text: obj.name,
                        value: obj.id
                    })
                );
            },

            getDefaultJob () {
                this.formData.jobs = [{ ...jobModel }]
                return this.formData.jobs
            },

            addJob () {
                this.formData.jobs.unshift({ ...jobModel });
            },

            deleteJob (job) {
                job.removed = true;
            },

            onFederalBlur () {
                this.$nextTick(() => this.getStatus());
            },

            onZipBlur () {
                this.$nextTick(() => this.getAddress());
            },

            beforeSave () {
                return !!this.federalError;

            },

            async getStatus () {
                if (this.$refs.atfCPF.valid) {
                    this.cpfResult = await this.$api.dataService.getData('client/federalData', { federalId: this.formData.federalId.toString().replaceAll('.', '').replaceAll('-', '') });
                    let res = await this.$api.dataService.search('client', { text: this.formData.federalId.toString().replaceAll('.', '').replaceAll('-', '') });
                    let data = await this.$api.dataService.getById('client', res[0].id);

                    if (this.cpfResult) {
                        if (this.cpfResult.status === 'I') {
                            this.assignData(this.cpfResult);
                            this.formStatus = { text: 'CPF Importado. Siga cadastrando as informações mais atuais.' };
                        } else if (this.cpfResult.status === 'D') {
                            this.$msg.confirm({
                                title: 'CPF já cadastrado',
                                message: `Deseja editar este cliente?`,
                                actions: ['Sim', 'Não'],
                                defaultAction: 0
                            }).then(async (action) => { if (action === 1) {
                                // this.federalError = ['CPF já Cadastrado'];
                                this.formData.federalId = '';
                            } else {
                                this.editRecord(res[0].id);
                                this.assignData(data);
                            }});
                        }
                    }
                }

                return true;
            },

            async getAddress () {
                let zipcode = this.$util.unformat(this.formData.zipcode, 0).toString();
                if (zipcode && zipcode.length === 8) {
                    this.loading = true;
                    let res = await this.$api.dataService.getData('api3/zipcode', { zipcode });
                    this.loading = false;
                    if (res) {
                        this.formData.address = res.logradouro;
                        this.formData.address2 = res.complemento;
                        this.formData.district = res.bairro;
                        this.formData.city = res.localidade;
                        this.formData.state = res.uf;
                    }
                }
            }
        }
    });
</script>

<style scoped>

   .form-status-card {
      background-color: darkorange;
      color: white;
      margin-top: -20px;
   }

   .form-status-card.alert {
      background-color: darkred;
   }

   .appended-btn {
      padding-top: 5px;
      font-size: 22px;
      top: 6px;
      position: relative;
   }

   #idDisplay {
      height: 57px;
      width: 100%;
      position: relative;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
   }

</style>



// WEBPACK FOOTER //
// src/pages/ClientForm.vue